type Unit = 'days' | 'hours' | 'minutes' | 'seconds';

function pad(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

function tick(root: HTMLElement, endMs: number): boolean {
  const now = Date.now();
  const dist = endMs - now;

  if (dist <= 0) {
    // nic nie pokazujemy, po prostu sygnalizujemy koniec
    return false;
  }

  let s = Math.floor(dist / 1000);
  const d = Math.floor(s / 86400);
  s -= d * 86400;
  const h = Math.floor(s / 3600);
  s -= h * 3600;
  const m = Math.floor(s / 60);
  s -= m * 60;

  const map: Record<Unit, string | number> = {
    days: pad(d),
    hours: pad(h),
    minutes: pad(m),
    seconds: pad(s),
  };

  root.querySelectorAll<HTMLElement>('[data-unit]').forEach((el) => {
    const u = el.getAttribute('data-unit') as Unit | null;
    if (!u) return;
    const val = map[u];
    if (val !== undefined) el.textContent = String(val);
  });

  return true;
}

function init(selector: string): void {
  document.querySelectorAll<HTMLElement>(selector).forEach((el) => {
    const iso = el.getAttribute('data-expire');
    if (!iso) return;

    const end = Date.parse(iso); // np. "2025-11-10T15:42:57+02:00"
    if (Number.isNaN(end)) return;

    // wstępne wyliczenie
    if (!tick(el, end)) return;

    const iv = window.setInterval(() => {
      if (!document.body.contains(el) || !tick(el, end)) {
        window.clearInterval(iv);
      }
    }, 1000);
  });
}

/** Publiczny init zgodnie z Twoją konwencją */
const initPromoCountdown = () => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init('.promo-countdown');
      init('.promo-countdown-mini');
    }, { once: true });
  } else {
    init('.promo-countdown');
    init('.promo-countdown-mini');
  }
};

export default initPromoCountdown;

// // Prosty, bez zależności. Działa z markupiem:
// // <div class="promo-countdown" data-expire="2025-12-31T23:59:59Z"> ... [data-unit] ... </div>
// // i/lub <div class="promo-countdown-mini" data-expire="..."></div>

// type Unit = "days" | "hours" | "minutes" | "seconds";

// function pad(n: number): string {
//   return n < 10 ? `0${n}` : String(n);
// }

// function tick(root: HTMLElement, endMs: number): void {
//   const now = Date.now();
//   const dist = endMs - now;

//   if (dist <= 0) {
//     root.innerHTML = '<div class="expired">Offer expired</div>';
//     return;
//   }

//   let s = Math.floor(dist / 1000);
//   const d = Math.floor(s / 86400);
//   s -= d * 86400;
//   const h = Math.floor(s / 3600);
//   s -= h * 3600;
//   const m = Math.floor(s / 60);
//   s -= m * 60;

//   const map: Record<Unit, string | number> = {
//     days: d,
//     hours: pad(h),
//     minutes: pad(m),
//     seconds: pad(s),
//   };

//   root.querySelectorAll<HTMLElement>("[data-unit]").forEach((el) => {
//     const u = el.getAttribute("data-unit") as Unit | null;
//     if (!u) return;
//     const val = map[u];
//     if (val !== undefined) el.textContent = String(val);
//   });
// }

// function init(selector: string): void {
//   document.querySelectorAll<HTMLElement>(selector).forEach((el) => {
//     const iso = el.getAttribute("data-expire");
//     if (!iso) return;

//     const end = Date.parse(iso);
//     if (Number.isNaN(end)) return;

//     // Wstępne wyliczenie
//     tick(el, end);

//     const iv = window.setInterval(() => {
//       if (!document.body.contains(el)) {
//         window.clearInterval(iv);
//         return;
//       }
//       tick(el, end);
//     }, 1000);
//   });
// }

// document.addEventListener("DOMContentLoaded", () => {
//   init(".promo-countdown");
//   init(".promo-countdown-mini");
// });

// (function () {
//   function pad(n) { return n < 10 ? '0' + n : '' + n; }

//   function tick(root, endDate) {
//     var now = new Date().getTime();
//     var dist = endDate - now;
//     if (dist <= 0) {
//       root.innerHTML = '<div class="expired">Offer expired</div>';
//       return;
//     }
//     var s = Math.floor(dist / 1000);
//     var d = Math.floor(s / 86400); s -= d * 86400;
//     var h = Math.floor(s / 3600);  s -= h * 3600;
//     var m = Math.floor(s / 60);    s -= m * 60;

//     var map = {
//       days: d, hours: pad(h), minutes: pad(m), seconds: pad(s)
//     };
//     root.querySelectorAll('[data-unit]').forEach(function(el){
//       var u = el.getAttribute('data-unit');
//       if (map[u] !== undefined) el.textContent = map[u];
//     });
//   }

//   function init(selector) {
//     document.querySelectorAll(selector).forEach(function (el) {
//       var iso = el.getAttribute('data-expire');
//       if (!iso) return;
//       var end = Date.parse(iso);
//       if (isNaN(end)) return;
//       // od razu policz
//       tick(el, end);
//       // aktualizuj co sekundę
//       var iv = setInterval(function () {
//         if (!document.body.contains(el)) { clearInterval(iv); return; }
//         tick(el, end);
//       }, 1000);
//     });
//   }

//   document.addEventListener('DOMContentLoaded', function () {
//     init('.promo-countdown');
//     init('.promo-countdown-mini');
//   });
// })();
